
// load locales
import en from './en/translation'
import ru from './ru/translation'

export default { en, ru }
